import sliceCreator from '../../index.jsx';
import {UPDATE_FARMER} from '../../../constants/index.jsx';
const _updateFarmerAction = sliceCreator('UPDATE_FARMER', UPDATE_FARMER, 'put');

const { asyncAction: updateFarmerAction, reducer, clearData: clearUpdateFarmerAction } = _updateFarmerAction;

export default reducer;

export {
    updateFarmerAction,
    clearUpdateFarmerAction
}